module.exports = __webpack_public_path__ + "static/media/productos_botanas_habaenchilada.54b048fe.png";